import virus from '../assets/virus.svg';
import bacteria from '../assets/bacteria.svg';
import fumes from '../assets/fumes.svg';
import dust from '../assets/dust.svg';
import player from '../assets/player.svg';
import airfilter from '../assets/airfilter.png';
import airpurifier from '../assets/airpurifier.png';
import facemask from '../assets/facemask.png';
import scarf from '../assets/scarf.png';

import { calculateSize } from './size';
import { gameSize } from './gameSize';

const resources = {
  virus,
  bacteria,
  fumes,
  dust,
  player,
  airfilter,
  airpurifier,
  facemask,
  scarf,
};

const resourceCache: Record<string, HTMLImageElement> = {};

export function loadResources(): Promise<void>[] {
  return Object.entries(resources).map(([key, url]) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => {
        resourceCache[key] = img;
        resolve();
      };
      img.src = url;
    });
  });
}

export function getResource(url: string) {
  return resourceCache[url];
}

export type Resource = {
  url: string;
  width: number;
  height: number;
};

export function renderResource(
  resource: Resource,
  ctx: CanvasRenderingContext2D,
  maxWidth: number
) {
  const [width, height] = calculateSize(resource, maxWidth);
  ctx.drawImage(
    getResource(resource.url),
    0,
    0,
    gameSize(width),
    gameSize(height)
  );
}
